/* swt_localStorage.js · records each viewed product for the "Recently viewed"
   rail (sections/swt_recent_viewed_products.liquid reads localStorage
   'recentlyViewed'). Loaded on product pages only (layout/theme.liquid).

   10-06-26 fix: the product page is now sections/swt-main-product.liquid,
   which has no <product-info> element. The old lookup threw on every
   product page, so nothing was recorded and the rail stopped updating.
   The handle now comes from the rail's data-current-handle (Liquid), then
   the canonical URL, then the page URL. Storage access is guarded, since
   it can throw in private windows or when blocked. */
document.addEventListener('DOMContentLoaded', function () {
	var KEY = 'recentlyViewed';
	var MAX = 50;

	function fromUrl(url) {
		var m = String(url || '').match(/\/products\/([^\/?#]+)/);
		if (!m) return '';
		try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
	}

	function currentHandle() {
		var host = document.querySelector('[data-current-handle]:not([data-current-handle=""])');
		if (host) return host.getAttribute('data-current-handle');
		var canonical = document.querySelector('link[rel="canonical"]');
		return fromUrl(canonical && canonical.getAttribute('href')) || fromUrl(window.location.pathname);
	}

	var handle = currentHandle();
	if (!handle) return;

	try {
		var list;
		try { list = JSON.parse(localStorage.getItem(KEY)); } catch (e) { list = null; }
		if (!Array.isArray(list)) list = [];
		list = list.filter(function (h) { return h !== handle; });
		list.unshift(handle);
		localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
	} catch (e) {
		/* storage unavailable or full: skip quietly */
	}
});
